import { c as _c } from "react/compiler-runtime";
import { ProcessedContent } from "./media-utils";
import ContentSegmentComponent from "./ContentSegmentComponent";
import MediaThumbnail from "./MediaThumbnail";
interface ContentDisplayProps {
  readonly content: ProcessedContent;
  readonly onReplyClick: (serialNo: number) => void;
  readonly serialNo?: number | undefined;
}

/**
 * Component to display processed content with text segments and media
 */
export default function ContentDisplay(t0) {
  const $ = _c(13);
  const {
    content,
    onReplyClick,
    serialNo
  } = t0;
  let t1;
  if ($[0] !== onReplyClick || $[1] !== serialNo) {
    t1 = () => {
      if (serialNo) {
        onReplyClick(serialNo);
      }
    };
    $[0] = onReplyClick;
    $[1] = serialNo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  let t2;
  if ($[3] !== content.segments) {
    t2 = content.segments.map(_temp);
    $[3] = content.segments;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span className="tw-line-clamp-1">{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== content.apiMedia) {
    t4 = content.apiMedia.map(_temp2);
    $[7] = content.apiMedia;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handleClick || $[10] !== t3 || $[11] !== t4) {
    t5 = <span className="tw-break-all tw-text-iron-300 tw-font-normal tw-text-sm hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out tw-cursor-pointer tw-flex tw-items-center tw-gap-1.5 tw-line-clamp-1" onClick={handleClick}>{t3}{t4}</span>;
    $[9] = handleClick;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp2(media, i_0) {
  return <MediaThumbnail key={`api-media-${i_0}`} media={media} />;
}
function _temp(segment, i) {
  return <ContentSegmentComponent key={`segment-${i}`} segment={segment} index={i} />;
}